module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/238e6e3168377669201e4f760032b4d3.png";